// Calendar state persistence — keeps the bookings page's last view + date
// available to downstream pages so breadcrumbs and the browser back button can
// both restore where the user was.
//
// The bookings page (FullCalendar) writes its current view + date here on
// every datesSet, and breadcrumb builders elsewhere read it back when
// constructing the "Appointments" crumb.

const SESSION_KEY = "practosync:bookingsState";

export function saveBookingsState({ view, date }) {
  try {
    sessionStorage.setItem(
      SESSION_KEY,
      JSON.stringify({ view: view || null, date: date || null })
    );
  } catch {
    /* sessionStorage unavailable — non-fatal */
  }
}

export function readBookingsState() {
  try {
    const raw = sessionStorage.getItem(SESSION_KEY);
    if (!raw) return null;
    const parsed = JSON.parse(raw);
    if (!parsed || (!parsed.view && !parsed.date)) return null;
    return parsed;
  } catch {
    return null;
  }
}

// Returns the path to use for an "Appointments" breadcrumb crumb. Includes
// `?view=...&date=...` when prior calendar state is known, so clicking the
// crumb returns the user to the same view + date they came from. Falls back
// to plain "/bookings" when no state is saved (eg. fresh session).
export function getBookingsReturnPath() {
  const state = readBookingsState();
  if (!state) return "/bookings";
  const params = new URLSearchParams();
  if (state.view) params.set("view", state.view);
  if (state.date) params.set("date", state.date);
  const qs = params.toString();
  return qs ? `/bookings?${qs}` : "/bookings";
}
